import type { SEmbedPosthogConfig } from "./analyticsProtocol";

export type SEmbedReadyMessage = { type: "S_EMBED_READY" };
export type SEmbedNavigationChangeMessage = {
  type: "S_EMBED_NAVIGATION_CHANGE";
  path: string;
};
export type SEmbedLinkMessage = { type: "S_EMBED_LINK"; url: string };
export type SEmbedPickerSelectMessage = {
  type: "S_EMBED_PICKER_SELECT";
  key: string;
  optionId: string;
};
export type SEmbedRefreshMessage = { type: "S_EMBED_REFRESH" };
export type SEmbedTokenMessage = {
  type: "S_EMBED_TOKEN";
  accessToken: string;
  refreshToken: string;
  expiresIn: number;
  dataContext?: string;
  host?: { navigation?: "host"; overlays?: "host" };
  posthog?: SEmbedPosthogConfig;
};

export type SEmbedHostMessage =
  | SEmbedReadyMessage
  | SEmbedNavigationChangeMessage
  | SEmbedLinkMessage
  | SEmbedPickerSelectMessage
  | SEmbedRefreshMessage;

export function isSEmbedHostMessage(value: unknown): value is SEmbedHostMessage {
  if (!value || typeof value !== "object") return false;
  const message = value as Record<string, unknown>;
  switch (message.type) {
    case "S_EMBED_READY":
    case "S_EMBED_REFRESH":
      return true;
    case "S_EMBED_NAVIGATION_CHANGE":
      return typeof message.path === "string";
    case "S_EMBED_LINK":
      return typeof message.url === "string";
    case "S_EMBED_PICKER_SELECT":
      return typeof message.key === "string" && typeof message.optionId === "string";
    default:
      return false;
  }
}
